/**
 * English catalogue. Every module is typed against its German counterpart, so a
 * missing key is a type error in the module that forgot it — in the file the
 * person who forgot it was editing.
 *
 * The merge below is deliberately dumb: a spread into a typed variable does not
 * trigger excess-property checking, so `test/i18n.test.ts` also asserts that the
 * two key sets are equal as sets.
 */
import { aircraft } from './en/aircraft';
import { auth } from './en/auth';
import { common } from './en/common';
import { exportKeys } from './en/export';
import { flight } from './en/flight';
import { flights } from './en/flights';
import { form } from './en/form';
import { map } from './en/map';
import { navlog } from './en/navlog';
import { settings } from './en/settings';
import { terrain } from './en/terrain';
import { weather } from './en/weather';
import type { de } from './de';

export const MODULES_EN = [
  common, flights, flight, navlog, weather, terrain, exportKeys, aircraft, settings, auth, map, form,
] as const;

export const en: Record<keyof typeof de, string> = {
  ...common,
  ...flights,
  ...flight,
  ...navlog,
  ...weather,
  ...terrain,
  ...exportKeys,
  ...aircraft,
  ...settings,
  ...auth,
  ...map,
  ...form,
};
